export const buildDomainIncidentsFilters = <T extends object>(urlFilters: T): T & {ignore: boolean} => ({
    ...urlFilters,
    ignore: false,
});
